import { Dropdown, type DropdownChangeEvent } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { useMemo } from "react";
import { type SalutationType } from "./salutation-dropdown.types";
import { getSalutationOptions } from "./salutation-dropdown.utils";
import { type RenderConfig } from "../ValidatedField";

export const SalutationDropdown = ({
	fieldName,
	fieldValue,
	updateField,
	disabled,
	onChange,
	isValid,
	required,
	placeholder,
}: RenderConfig<SalutationType>) => {
	const checkIfDropdownFieldChanged = (e: any) => {
		if (e.value !== fieldValue) {
			if (onChange) {
				onChange();
			}
		}
	};

	const salutationOptions = useMemo(() => getSalutationOptions(), []);

	return (
		<Dropdown
			options={salutationOptions}
			name={fieldName}
			disabled={disabled}
			required={required}
			placeholder={placeholder}
			onChange={(dropdownChangeEvent: DropdownChangeEvent) => {
				updateField(dropdownChangeEvent.value);
				checkIfDropdownFieldChanged(dropdownChangeEvent.value);
			}}
			value={fieldValue}
			className={classNames({ "p-invalid": !isValid })}
		/>
	);
};
